import React, { memo } from 'react'
import ColorTicket from './ColorTicket'
import { ColoriFormatiPageConfig } from '../../configuration'
import { makeStyles } from '@material-ui/core/styles'
import { tablet } from '../mediaQueries'

export const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 17.5px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            maxWidth: 'calc(100vw - 1rem)',
            margin: 'auto',
            marginTop: '25px'
        }
    },
    mobileRoot: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: 'calc(100vw - 1rem)',
        alignItems: 'center',
        flexDirection: 'column',
        margin: 'auto',
        marginTop: '50px'
    },
    p: {
        color: '#575452',
        margin: 0,
        whiteSpace: 'pre',
        letterSpacing: '0.08em',
        marginBottom: '1rem',
        fontFamily: 'Aktiv Grotesk',
        textTransform: 'uppercase',
        lineHeight: '140%'
    },
    scroller: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            justifyContent: 'flex-start',
            maxWidth: '100%',
            overflowX: 'scroll',
            flexDirection: 'row'
        }
    }
})

const useStyles = makeStyles(styles)

function ColorPicker({ index, handleFade, setVisibleColor }) {
    const classes = useStyles()
    return (
        <div className={classes.root} >
            <p className={classes.p} >{ColoriFormatiPageConfig.content.tertiary[1]}</p>
            <div className={classes.scroller} >
                {ColoriFormatiPageConfig.colors.map((e, i) => {
                    return <ColorTicket
                        changeFade={handleFade}
                        key={i}
                        setVisibleColor={setVisibleColor}
                        index={i}
                        active={i === index}
                        name={e.name}
                        image={e.src}
                    />
                })}
            </div>
        </div>
    )
}

export default memo(ColorPicker)